import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-3cf3bccd"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "page-main"
};
const _hoisted_2 = ["src"];

const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"top-right\" data-v-3cf3bccd><p class=\"game-name\" data-v-3cf3bccd>超人气：救救狗狗</p><div class=\"info-back\" data-v-3cf3bccd><div class=\"info-item\" data-v-3cf3bccd><p data-v-3cf3bccd>4.8★</p><p data-v-3cf3bccd>10.9万条评分</p></div><div class=\"info-item\" data-v-3cf3bccd><p data-v-3cf3bccd>500万+</p><p data-v-3cf3bccd>下载次数</p></div><div class=\"info-item\" data-v-3cf3bccd><div class=\"age\" data-v-3cf3bccd>3+</div><p data-v-3cf3bccd>3岁以上</p></div></div></div>", 1);

const _hoisted_4 = {
  class: "down-back"
};
const _hoisted_5 = {
  class: "douyin-back"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "douyin-word"
};
const _hoisted_8 = {
  key: 0
};

const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 抖音超级网红！");

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));

const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 百万分享！ ");

const _hoisted_12 = [_hoisted_9, _hoisted_10, _hoisted_11];
const _hoisted_13 = {
  key: 1
};
const _hoisted_14 = ["src"];
const _hoisted_15 = ["src"];
const _hoisted_16 = ["src"];
const _hoisted_17 = ["src"];
const _hoisted_18 = ["src"];
const _hoisted_19 = ["src"];
const _hoisted_20 = {
  key: 2,
  class: "hide-div"
};
const _hoisted_21 = ["src"];
const _hoisted_22 = ["src"];
const _hoisted_23 = ["src"];
const _hoisted_24 = ["src"];
const _hoisted_25 = ["src"];
const _hoisted_26 = ["src"];
const _hoisted_27 = ["src"];
const _hoisted_28 = ["src"];
const _hoisted_29 = {
  class: "bottom-tips"
};
const _hoisted_30 = {
  class: "bottom-backs"
};
const _hoisted_31 = {
  class: "bottom-left"
};
const _hoisted_32 = ["src"];

const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "douyin-word"
}, "2022最火小游戏！", -1));

const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bottom-back"
}, null, -1));

const _hoisted_35 = ["src"];
const _hoisted_36 = {
  class: "tips-val"
};

const _hoisted_37 = /*#__PURE__*/_createTextVNode(" 点击右上角使用");

const _hoisted_38 = ["src"];

const _hoisted_39 = /*#__PURE__*/_createTextVNode("浏览器打开 ");

const _hoisted_40 = {
  key: 4,
  class: "hide_back"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_swipe_item = _resolveComponent("van-swipe-item");

  const _component_van_swipe = _resolveComponent("van-swipe");

  return _openBlock(), _createElementBlock("div", {
    class: "main",
    onClick: _cache[5] || (_cache[5] = (...args) => $setup.topClick && $setup.topClick(...args))
  }, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
    src: $setup.logo,
    class: "app-icon",
    ondragstart: "return false"
  }, null, 8, _hoisted_2), _hoisted_3]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
    class: "down-btn",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.down && $setup.down(...args))
  }, " 安装 "), _createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
    src: $setup.douyin,
    class: "douyin-img",
    ondragstart: "return false"
  }, null, 8, _hoisted_6), _createElementVNode("div", _hoisted_7, [$setup.isMobile ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_12)) : (_openBlock(), _createElementBlock("div", _hoisted_13, "抖音超级网红！百万分享！快来试试！"))])])]), $setup.isMobile ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: $setup.video,
    class: "video"
  }, null, 8, _hoisted_14)) : _createCommentVNode("", true), $setup.isMobile ? (_openBlock(), _createBlock(_component_van_swipe, {
    key: 1,
    class: "swipe"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_swipe_item, null, {
      default: _withCtx(() => [_createElementVNode("img", {
        src: $setup.img1,
        class: "img-item"
      }, null, 8, _hoisted_15)]),
      _: 1
    }), _createVNode(_component_van_swipe_item, null, {
      default: _withCtx(() => [_createElementVNode("img", {
        src: $setup.img2,
        class: "img-item"
      }, null, 8, _hoisted_16)]),
      _: 1
    }), _createVNode(_component_van_swipe_item, null, {
      default: _withCtx(() => [_createElementVNode("img", {
        src: $setup.img3,
        class: "img-item"
      }, null, 8, _hoisted_17)]),
      _: 1
    }), _createVNode(_component_van_swipe_item, null, {
      default: _withCtx(() => [_createElementVNode("img", {
        src: $setup.img4,
        class: "img-item"
      }, null, 8, _hoisted_18)]),
      _: 1
    }), _createVNode(_component_van_swipe_item, null, {
      default: _withCtx(() => [_createElementVNode("img", {
        src: $setup.img5,
        class: "img-item"
      }, null, 8, _hoisted_19)]),
      _: 1
    })]),
    _: 1
  })) : (_openBlock(), _createElementBlock("div", _hoisted_20, [$setup.margin < 0 ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: $setup.left,
    class: "left-icon",
    onClick: _cache[1] || (_cache[1] = (...args) => $setup.toLeft && $setup.toLeft(...args)),
    ondragstart: "return false"
  }, null, 8, _hoisted_21)) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "scroll-div",
    style: _normalizeStyle({
      'margin-left': $setup.margin + 'px'
    })
  }, [_createElementVNode("img", {
    src: $setup.video,
    class: "img-pc-item",
    ondragstart: "return false"
  }, null, 8, _hoisted_22), _createElementVNode("img", {
    src: $setup.img1,
    class: "img-pc-item",
    ondragstart: "return false"
  }, null, 8, _hoisted_23), _createElementVNode("img", {
    src: $setup.img2,
    class: "img-pc-item",
    ondragstart: "return false"
  }, null, 8, _hoisted_24), _createElementVNode("img", {
    src: $setup.img3,
    class: "img-pc-item",
    ondragstart: "return false"
  }, null, 8, _hoisted_25), _createElementVNode("img", {
    src: $setup.img4,
    class: "img-pc-item",
    ondragstart: "return false"
  }, null, 8, _hoisted_26), _createElementVNode("img", {
    src: $setup.img5,
    class: "img-pc-item",
    ondragstart: "return false"
  }, null, 8, _hoisted_27)], 4), $setup.margin > -1000 ? (_openBlock(), _createElementBlock("img", {
    key: 1,
    src: $setup.right,
    class: "right-icon",
    onClick: _cache[2] || (_cache[2] = (...args) => $setup.toRight && $setup.toRight(...args)),
    ondragstart: "return false"
  }, null, 8, _hoisted_28)) : _createCommentVNode("", true)])), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_createElementVNode("img", {
    src: $setup.douyin,
    class: "douyin-img"
  }, null, 8, _hoisted_32), _hoisted_33]), _createElementVNode("div", {
    class: "down-btn",
    onClick: _cache[3] || (_cache[3] = (...args) => $setup.down && $setup.down(...args))
  }, " 立即试玩 ")])]), _hoisted_34, $setup.isWechat && $setup.show ? (_openBlock(), _createElementBlock("div", {
    key: 3,
    class: "share-back",
    onClick: _cache[4] || (_cache[4] = (...args) => $setup.close && $setup.close(...args))
  }, [_createElementVNode("img", {
    src: $setup.wechatjt,
    class: "wechatjt",
    ondragstart: "return false"
  }, null, 8, _hoisted_35), _createElementVNode("div", _hoisted_36, [_hoisted_37, $setup.isIos ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: $setup.safari,
    class: "safari"
  }, null, 8, _hoisted_38)) : _createCommentVNode("", true), _hoisted_39])])) : _createCommentVNode("", true), $setup.isWechat && $setup.show ? (_openBlock(), _createElementBlock("div", _hoisted_40)) : _createCommentVNode("", true)])]);
}